import { amplifyApiRef } from './types';

import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

import { AmplifyBackendClient } from './api/AmplifyBackendClient';


export const amplifyPlugin = createPlugin({
  id: 'amplify',
  apis: [
    createApiFactory({
      api: amplifyApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
      },
      factory: ({ discoveryApi }) =>
        new AmplifyBackendClient({ discoveryApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const AmplifyPage = amplifyPlugin.provide(
  createRoutableExtension({
    name: 'AmplifyPage',
    component: () =>
      import('./components/ExampleComponent').then(m => m.ExampleComponent),
    mountPoint: rootRouteRef,
  }),
);
